export default __webpack_public_path__ + "img/landscape_0.8dc8c8063ce0a3745b3620ceabaaa408.jpg";